import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    testimonials: [],
    isTestimonialsLoading: false

}


export const getTestimonials = createAsyncThunk(
    'get_testimonials_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getTestimonialsStart());
            const response = await axios.get(`/testimonials/get_testimonials.php`)
            console.log('response of testimonials', response?.data?.data)
            if (response?.data?.status == 'success') {

                dispatch(getTestimonialsSuccess(response?.data?.data))
            }


        } catch (error) {
            dispatch(getTestimonialsFailure(error.response.data.message))
        }
    }
)
export const addTestimonial = createAsyncThunk(
    "addtestimonials",
    async (data, { dispatch, rejectWithValue }) => {
        console.log('data os testimonialsData ', data)
        try {
            dispatch(addTestimonialsStart());
            const response = await axios.post(`/testimonials/add_testimonial.php`, data);
            dispatch(addTestimonialsSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getTestimonials())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addTestimonialsFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteTestimonial = createAsyncThunk('deletetestimonial', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateTestimonialsStart());
        const response = await axios.delete(`/testimonials/delete_testimonials.php?id=${id}`);
        if (response?.data?.status == 'success') {
            dispatch(getTestimonials())
            // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
        }
        return response.data
    } catch (error) {
        // SHOW_ERROR_NOTIFICATION(error.response.data.message);
        return rejectWithValue(error.response.data.message);
    }
})
export const updateTestimonial = createAsyncThunk(
    "addtestimonials",
    async ({ data }, { dispatch, rejectWithValue }) => {
        console.log('data os testimonialsData ', data)
        try {
            dispatch(updateTestimonialsStart());
            const response = await axios.post(`/testimonials/update_testimonial.php`, data);
            dispatch(updateTestimonialsSuccess(response.data?.user));
            if (response?.data?.status == 'success') {
                dispatch(getTestimonials())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(updateTestimonialsFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);

const testimonialsSlice = createSlice({
    name: 'testimonials',
    initialState,
    reducers: {
        getTestimonialsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getTestimonialsSuccess(state, action) {

            state.testimonials = action.payload;
            state.isLoading = false;
        },
        getTestimonialsFailure(state, action) {
            state.testimonials = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addTestimonialsStart(state) {
            state.isTestimonialsLoading = true;
            state.error = null;
        },
        addTestimonialsSuccess(state, action) {
            state.user = action.payload;
            state.isTestimonialsLoading = false;
        },
        addTestimonialsFailure(state, action) {
            state.error = action.payload;
            state.isTestimonialsLoading = false;
        },

        updateTestimonialsStart(state) {
            state.isTestimonialsLoading = true;
            state.error = null;
        },
        updateTestimonialsSuccess(state, action) {
            state.user = action.payload;
            state.isTestimonialsLoading = false;
        },
        updateTestimonialsFailure(state, action) {
            state.error = action.payload;
            state.isTestimonialsLoading = false;
        },
    }
})

export const { getTestimonialsSuccess, getTestimonialsStart, getTestimonialsFailure, addTestimonialsStart, addTestimonialsSuccess, addTestimonialsFailure, updateTestimonialsStart, updateTestimonialsSuccess, updateTestimonialsFailure } = testimonialsSlice.actions;

export default testimonialsSlice.reducer;